import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-funcion',
  templateUrl: './funcion.component.html',
  styleUrls: ['./funcion.component.css']
})
export class FuncionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
